import React from 'react';
import { Typography, Grid } from 'antd';

const { Title } = Typography;
const { useBreakpoint } = Grid;

interface DashboardHeaderProps {
  sortBy: string;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({ sortBy }) => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  return (
    <Title
      level={isMobile ? 4 : 2}
      style={{
        margin: 0,
        marginBottom: 0,
        fontSize: isMobile ? 18 : 30,
      }}
    >
      {sortBy === 'dm' ? 'LOCATIONS BY DM' : 'LOCATIONS BY SALES TIER'}
    </Title>
  );
};

